import axios from "@/api/axiosInstance";
import {
  DataEnvelope,
  Enrollment,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Re-enroll the caller in a previously cancelled enrollment, restoring its
// prior progress.
export const reactivateEnrollment = async (
  enrollmentUuid: string,
): Promise<Enrollment> => {
  const response = await axios.post<DataEnvelope<Enrollment>>(
    `/api/private/learning-center/enrollments/${enrollmentUuid}/reactivate`,
  );
  return response.data.data;
};
